<div class="td-wb-modal-notification">
  <div class="td-wb-modal-notification-recurring-transfers__row">
    <h1 class="td-wb-modal-notification-recurring-transfers__title td-wb-modal-notification__header"
        translate="tdWb.modalNotification.recurringTransfers.TITLE"></h1>
    <div class="td-wb-modal-notification-recurring-transfers__desc">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.recurringTransfers.DESCRIPTION_I"></p>
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.recurringTransfers.DESCRIPTION_II"></p>
      <p class="td-wb-modal-notification__copy">
        <a href="#/modal/transfers/cash"
            translate="tdWb.modalNotification.recurringTransfers.START_TRANSFER"></a>
      </p>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           [src]="('tdWb.modalNotification.recurringTransfers.IMAGE' | translate)"
           [attr.alt]="'tdWb.modalNotification.recurringTransfers.IMAGE_ALT' | translate"
           aria-hidden="true"
           class="td-wb-modal-notification--image-small"
      />
    </div>
  </div>
</div>
